import { useMemo } from 'react'
import { HOLIDAYS } from '@/views/TicketCheckoutViews/ShowtimesView/components/HolidayDates/holidayConstants'
import type { Holiday } from '@/views/TicketCheckoutViews/ShowtimesView/components/HolidayDates/holidayConstants'

interface UseHolidayReturn {
  checkHoliday: (date: Date) => Holiday | null
  getAllHolidays: () => Record<string, Holiday>
}

export function useHoliday(): UseHolidayReturn {
  return useMemo(() => {
    const checkHoliday = (date: Date): Holiday | null => {
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      const monthDay = `${month}-${day}`

      return monthDay in HOLIDAYS ? HOLIDAYS[monthDay] : null
    }

    const getAllHolidays = (): Record<string, Holiday> => {
      return HOLIDAYS
    }

    return {
      checkHoliday,
      getAllHolidays,
    }
  }, [])
}
